import React from "react";
import { Box, Grid } from "@mui/material";
import { AppLayout } from "layout";
import {

  SettingData,
} from "modules/Setting/components";

type Props = {};

const SettingContainer = (props: Props) => {

  return (
    <AppLayout>
      <SettingData />
    </AppLayout>
  );
};

export default SettingContainer;
